import { Radio, RadioProps, styled } from '@mui/material';

export const ARadiobutton = styled((props: RadioProps) => <Radio {...props} />)({
    color: '#02584B',
    '&.Mui-checked': {
        color: '#02584B',
    },
});
